// extracted by mini-css-extract-plugin
export var progressContainer = "_j6-0";